import { render } from "./Filter.vue?vue&type=template&id=778eb610"
const script = {}
script.render = render

export default script